"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.SMS_OUT_PLATFORM = void 0;
exports.SMS_OUT_PLATFORM = { API: 1, WEB: 2 };
